import { motion } from "framer-motion"
import LottiePlayer from "lottie-react"
import { useEffect, useState } from "react"
import { FiArrowLeft } from "react-icons/fi"
import { useNavigate } from "react-router-dom"
import { useRecoilState, useRecoilValue } from "recoil"
import loadingAnimation from "../animations/loader.json"
import { currentCart } from "../atoms/auth"
import { orderAtom } from "../atoms/checkoutManager"
import configAtom from "../atoms/configAtom"
import { auth } from "../functions/firebase"
import notify from "../functions/notify"
import { submitOrder } from "../functions/submitOrder"

const deliveryFees = [
    //campus 5
    { n: "Campus", p: 5 },
    //phaphala 15
    { n: "Phala-Phala", p: 15 },
    //jerusalema 15
    { n: "Jerusalema", p: 10 },
    //p west 15
    { n: "P-West", p: 10 },
    //maungani-next-to-gate 15
    { n: "Maungani Next To Gate", p: 10 },
    //maugani-aftergate 20 
    { n: "Maungani Aftergate", p: 10 },
    // golgotha 15
    { n: "Golgotha", p: 10 },
    //cosco 15
    { n: "Cosco", p: 15 },
    //little-star 15
    { n: "Little Star", p: 15 },
    //simeka 20
    { n: "Simeka", p: 15 },
    // grand royal 25
    { n: "Grand Royal", p: 25 },
    // forest hill 20
    { n: "Forest Hill", p: 20 },
    //river estate 30
    { n: "River Estate", p: 30 },
    // 3 MTR 30
    { n: "3 MTR", p: 15 },
    // j&R tour 20
    { n: "J&R Tour", p: 20 },
    // royal hill 25
    { n: "Royal Hill", p: 25 },
    //bervely hills 15
    { n: "Bervely Hills", p: 15 },
    //muthathe 25
    { n: "Muthathe", p: 25 },
    //emlanjeni 15
    { n: "Emplanjeni", p: 15 },
    //mapula res 15
    { n: "Mapula Res", p: 15 },
    //vhugalahawe 15
    { n: "Vhugalahawe", p: 10 },
    //west gate 10
    { n: "West Gate", p: 5 },
    //yellow-stone 15
    { n: "Yellow Stone", p: 15 },
    //green-stone 15
    { n: "Green Stone", p: 15 },
    //botanical garden 15
    { n: "Bonitical Gardens", p: 15 },
    //ngovhela res 15
    { n: "Ngovhela Red", p: 15 },
    //ngovhela-backside 30
    { n: "Ngovhela Backside", p: 15 },
    //sandton 15
    { n: "Sandton", p: 15 },
    //OGT 15
    { n: "OGT", p: 15 },
    //parkview 15
    { n: "Parkview", p: 15 },
    //pfunzo-house 15
    { n: "Punzo House", p: 15 },
    //thavhani-mall 15
    { n: "Thavhani Mall", p: 15 },
    // mulovhedzi 20
    { n: "Mulovhedzi", p: 15 },
    //p-ease 15
    { n: "P East", p: 15 },
    //mmemuthagu 20
    { n: "Mme-Muthagu", p: 20 },
    // pishon house 15
    { n: "Pishon House", p: 15 },
    //madrenis 15
    { n: "Magrenis", p: 15 },
    //makhode 15
    { n: "Makonde", p: 15 },
    //ngovhela hill side 30
    { n: "Ngovhela Hill Side", p: 30 },
    //tshilidzini 30
    { n: "Tshilidzini", p: 30 },
    //mvusuludzo 15
    { n: "Mvusuludzo", p: 15 },
    // plaza 15
    { n: "Plaza", p: 15 },
    //sibasa 25
    { n: "Sibasa", p: 25 },
    //makwarela 30
    { n: "Makwarela", p: 30 },
    //shayandima 30
    { n: "Shayandima", p: 30 },
    //muledane 25
    { n: "Muledane", p: 25 },
    //vhatanzi 30
    { n: "Vhatanzi", p: 30 },
]    

export default function Checkout() {

    const navigate = useNavigate()
    const [order, setOrder] = useRecoilState(orderAtom)
    const cart = useRecoilValue(currentCart)
    const orderTotal = cart.map(c => (Number(c.price) * c.quantity) + c.optionsTotal).reduce((a,b) => a + b, 0)
    const [loading, setLoading] = useState(false)
    const config = useRecoilValue(configAtom)
    const serviceFee = order.type === "collect" ? 1 : 2
    const total = orderTotal + order.deliveryCharge + serviceFee + (order.payment === "Transfer + R5.00 Fee" ? 5 : 0)

    useEffect(() => {

        setOrder(c => ({
            ...c,
            phone: localStorage.getItem("phone"),
            phoneNumber: localStorage.getItem("phone"),
            cash: c.payment === "cash" ? total : 0,
            card: c.payment === "speedpoint" ? total : 0,
            transfer: c.payment === "Transfer + R5.00 Fee" ? total : 0,
            type: config?.allowCollect ? "collect" : (config?.allowDelivery ? "delivery" : ""),
            serviceFee
        }))

    }, [config])

    useEffect(() => {

        if(order.type === "delivery") {
            setOrder(c => ({ 
                ...c, 
                deliveryCharge: Number(deliveryFees[0].p),
                deliveryPlace: deliveryFees[0].n
            }))
        } 


    }, [order.type])

    const signButton = <motion.div initial={{ y: 15, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.2 }} id="checkoutButton" style={{ display: 'block' }} >
    <button 
        style={{ 
            backgroundColor: "var(--primary)", 
            width: "calc(100% - 20px)", 
            whiteSpace: "nowrap", 
            margin: 10
        }}
        disabled={order.items.length === 0}
        onClick={async () => {

            const total = orderTotal + (order?.type === "delivery" ? order.deliveryCharge : 0) + serviceFee + (order.payment === "Transfer + R5.00 Fee" ? 5 : 0)
 
            if(!order.type || !order.payment) {
                return window.alert("Please add order type and payment method")
            }

            if(!config.allowCollect && !config.allowDelivery) {
                return window.alert("We are currently not taking orders, sorry")
            }

            if(!config.allowCollect && order.type === "collect") {
                return window.alert("Sorry, we are not taking orders for collect")
            }

            if(!config.allowDelivery && order.type === "delivery") {
                return window.alert("Sorry, we are not taking deliveries at the moment.")
            } 
            
            if(order.type === "delivery" && !order.note) {
                return window.alert("please describe your delivery location")
            }
            
            if(order.payment === "cash" && !order.amountInHand) {
                return window.alert("Please enter the amount you have for change")
            }

            if(order.payment === "cash" && order.amountInHand < total) {
                return window.alert("Amount in hand should be above the order total")
            }


            if(order.type === "collect") {

                const resp = window.prompt("Are you sure this order is not for delivery? (yes/no)", "yes")

                if(!resp || resp === "yes") {
                    //continue

                } else {

                    window.alert("Please select correct delivery location")

                    return setOrder(c => ({ ...c, type: "delivery" }))

                }
            }

            setLoading(true)
 
            await submitOrder({
                ...order,
                cash: order.payment === "cash" ? total : order.cash,
                card: order.payment === "speedpoint" ? total : order.card,
                transfer: order.payment === "Transfer + R5.00 Fee" ? total : order.transfer,
                total: total,
                charge: total,
                note: (order.type === "delivery" ? (order.deliveryPlace + ": " + order.note) : ""),
                title: localStorage.getItem("name"),
                date: new Date().toISOString(),
                online: true
            }).then(async () => {
                setLoading(false)
                navigate(`/auth-1/${auth.currentUser?.uid}/cart/checkout/success`)
                notify()
            }).catch(err => {
                window.alert(err.message)
                setLoading(false)
            })

        }}

    >Submit Order Now</button>

</motion.div>
    
    return (
        <>
            <motion.div whileTap={{ opacity: 0.7 }} transition={{ duration: 0.1 }}
                    onClick={() => navigate(`/auth-1/${auth?.currentUser?.uid}`)}
                    className="row centerX" style={{ width: "100%", padding: 15, backgroundColor: "var(--header)", marginBottom: 15 }}
                >
                <FiArrowLeft 
                    color="grey"
                    className="back-button"
                    size={30}
                    
                />
                <div>
                    <p>Checking Out</p>
                </div>
            </motion.div> 
            <div id="checkout-wrapper">
                <motion.div initial={{ y: 15, opacity: 0 }} animate={{ y: 0, opacity: 1 }} style={{ padding: "0 20px" }}>
                    <>
                        <div>
                            <p style={{ marginBottom: 5, fontSize: 13 }}>
                                Phonenumber
                            </p>
                        </div>
                       <input 
                            type="tel"
                            value={order.phone}
                            onChange={e => setOrder(c => ({ ...c, phone: (e.target.value)}))}
                           />
                    </>
                    <div>
                        <div>
                            <p style={{ marginBottom: 5, fontSize: 13 }}>Order Type</p>
                        </div>
                        <select name="order type" value={order.type} onChange={e => {

                            if(e.target.value === "collect") {
                                setOrder(c => ({ ...c, type: e.target.value, deliveryCharge: 0 })) 

                            } else {
                                setOrder(c => ({ ...c, type: e.target.value })) 
                            }

                        }} title="Order Type" placeholder="How Do You Want Your Order?" id="cats" style={{ width: "100%", margin: 0, backgroundColor: "#FFF", color: "#0ne", borderRadius: 10 }} 
                        >
                            <option value={""}>How Do You Want Your Order?</option>
                            {config?.allowDelivery && <option value="delivery">Deliver To Me</option>}
                            {config?.allowCollect && <option value="collect">I'll Collect When Ready</option>}
                        </select>
                    </div>
                    <br />
                    {order.type === "delivery" && (
                        <>
                            <div>
                                <div>
                                    <p style={{ fontWeight: "bold", marginBottom: 5, fontSize: 13 }}>Destination</p>
                                </div>
                                <select name="order type" value={order.deliveryPlace} onChange={e => {
                                    setOrder(c => ({ 
                                        ...c, 
                                        deliveryCharge: Number(deliveryFees.find(c => c.n === e.target.value)?.p) ,
                                        deliveryPlace: e.target.value
                                    }))
                                }} title="Order Type" id="selectPlace" style={{ width: "100%", margin: 0, backgroundColor: "#FFF", order: "none", borderRadius: 10 }} 
                                >
                                    {deliveryFees.map(d => (
                                        <option key={d.n} value={d.n}>
                                            {d.n}: R{d.p.toFixed(2)}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <br />
                            <div>
                                <div>
                                    <p style={{ fontWeight: "bold", marginBottom: 5, fontSize: 13 }}>Destination Description</p>
                                </div>
                                <textarea placeholder="Describe your exact location"
                                    value={order.note}
                                    onChange={e => setOrder(c => ({ ...c, note: e.target.value }))}
                                />
                            </div>
                            <br />
                        </>
                    )}

                    {order.type && <div >
                        <div>
                            <p style={{ marginBottom: 5, fontSize: 13  }}>Payment Type</p>
                        </div>
                        <select placeholder="How will you be paying?" id="cats" style={{ width: "100%", margin: 0, backgroundColor: "#FFF", color: "#000", borderRadius: 10 }} 
                        value={order.payment} onChange={e => setOrder(c => ({ 
                            ...c, 
                            payment: e.target.value,
                            cash: e.target.value === "cash" ? total : 0,
                            card: e.target.value === "card" ? total : 0,
                            transfer: e.target.value === "transfer" ? total : 0
                        }))}
                        >
                            <option value={""}>How Will You Be Paying?</option>
                            {config?.allowCash && <option value="cash">Cash</option>}
                            {config?.allowTransfer && <option value="Transfer + R5.00 Fee">Transfer (+R5 Fee)</option>}
                            {config?.allowCard && <option value="speedpoint">Card</option>}
                            {config.allowSplit && <option value="split">Split Payment</option>}
                        </select>
                    </div>}

                    {order.payment === "Transfer + R5.00 Fee" && (
                        <>
                        <br/>
                        <p style={{  marginBottom: 5, fontSize: 13, color: 'red' }}>R5 transfer fee will be charged</p>
                        </>
                    )}
                    {order.payment === "cash" && <>
                        <br/>
                        <p style={{  marginBottom: 5, fontSize: 13 }}>Amount in hand?</p>
                        <input 
                            type="number"
                            value={Number(order.amountInHand)}
                            onChange={e => setOrder(c => ({ 
                                ...c, 
                                amountInHand: Number(e.target.value)
                        }))}
                            />
                    </>}
                    {order.payment === "split" && (
                        <>
                            <br/>
                            <div id="split-payment" >
                                <div>
                                    <p style={{  marginBottom: 10 }}>Cash</p>
                                    <input 
                                        type="number"
                                        value={Number(order.cash)}
                                        onChange={e => setOrder(c => ({ ...c, cash: Number(e.target.value)}))}
                                    />
                                </div>
                                <div>
                                    <p style={{  marginBottom: 10 }}>Card</p>
                                    <input 
                                        type="number"
                                        value={Number(order.card)}
                                        onChange={e => setOrder(c => ({ ...c, card: Number(e.target.value)}))}
                                    />
                                </div>
                                <div>
                                    <p style={{  marginBottom: 10 }}>Transfer</p>
                                    <input 
                                        type="number"
                                        value={Number(order.transfer)}
                                        onChange={e => setOrder(c => ({ ...c, transfer: Number(e.target.value)}))}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    <br/>
                </motion.div>
                <div>
                    <div style={{  margin: '0px 20px', backgroundColor: "#FFF", color: "#000", borderRadius: 10, padding: "15px 10px", borderWidth: 1, borderColor: "rgb(209, 209, 209)" }}>
                        <div className="row spaceBetween">
                            <p>Cart Total</p>
                            <p style={{ fontWeight: "bold" }}>R{orderTotal.toFixed(2)}</p>
                        </div>
                        <br/>
                        {order.type === "delivery"  && (
                            <>
                                <div className="row spaceBetween">
                                    <p>Delivery Fee</p>
                                    <p style={{ fontWeight: "bold" }}>R{order.deliveryCharge?.toFixed(2)}</p>
                                </div>
                                <br/>
                            </>
                        )}
                        {order.payment === "Transfer + R5.00 Fee" && (
                            <>
                                <div className="row spaceBetween">
                                    <p>Transfer Fee</p>
                                    <p style={{ fontWeight: "bold" }}>R5.00</p>
                                </div>
                                <br/>
                            </>
                        )}
                        <div className="row spaceBetween">
                            <p>Service Fee</p>
                            <p style={{ fontWeight: "bold" }}>R{serviceFee}.00</p>
                        </div>
                        <br/>
                        <div className="row spaceBetween">
                            <p>Your order total</p>
                            <p style={{ fontWeight: "bold" }}>R{(orderTotal + order.deliveryCharge + serviceFee + (order.payment === "Transfer + R5.00 Fee" ? 5 : 0)).toFixed(2)}</p>
                        </div>
                    </div>

                    <p>{config.message}</p>
                    {window.innerWidth >= 480 && signButton}
                </div>
            </div>
            {window.innerWidth < 480 && <div style={{ height: 100, width: 20 }} />}
            {window.innerWidth < 480 && signButton}
            
            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    width: '100vw',
                    height: "100vh",
                    backgroundColor: '#171717',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <LottiePlayer 
                        animationData={loadingAnimation}
                        loop={true}
                        style={{
                            width: 200,
                        }}
                    />
                </div>
            )}
        </>
    )
}